import lodash from 'lodash';

export function peek(array) {
    return array[array.length - 1];
}

export function removeSelectedOptionsFromAllDocumentTypes(docTypes, currentExpectations) {
    const availableDocTypes = lodash.differenceWith(docTypes, currentExpectations, (docType, expectation) =>
        docType.displayName === expectation.name && docType.id === expectation.sourceId && docType.type !== 'staff'
    );
    return lodash.orderBy(availableDocTypes, [documentType => documentType.displayName.toLowerCase()]);
}

export function getDocumentTypesWithAssignedRoles(staffDocumentsTypes, studyRoles) {
    const docTypesWithRoles = [];
    lodash.forEach(staffDocumentsTypes, (docType) => {
        
        if(!(docType && docType.studyRoleId)) { 
            return; 
        }

        const role = lodash.find(studyRoles, role => role.id === docType.studyRoleId);    
        if(lodash.isEmpty(role)) { 
            return; 
        }
        
        const initiallyAssignedRole = { ...role, isInitiallyAssigned: true};
        const docTypeWithRole = lodash.find(docTypesWithRoles, docTypeWithRoles => docTypeWithRoles.documentTypeId === docType.sourceId);
        if(docTypeWithRole) {
            docTypeWithRole.roles.push(initiallyAssignedRole);
        }else {
            docTypesWithRoles.push({ documentTypeId: docType.sourceId, roles: [initiallyAssignedRole]});
        }
    });
    return docTypesWithRoles;
}

export function getAvailableStudyRolesWithAssigned(availableStudyRoles, assignedRoles) {
    return availableStudyRoles.map(studyRole => ({
        ...studyRole,
        isInitiallyAssigned: lodash.find(assignedRoles, assignedRole => assignedRole.id === studyRole.id && assignedRole.isInitiallyAssigned) ? true: false
    }));
}

export function getRolesAssignedToActiveDocumentType(rolesToDocumentType, activeDocTypeId) {
    const found = lodash.find(rolesToDocumentType, x => x.documentTypeId == activeDocTypeId);
    if (!found) {
        return [];
    }
    return found.roles;
}

export function mapRolesToDocumentTypes(selectedDocTypes, rolesToDocumentType) {
    const docTypesWithRoles = selectedDocTypes.map(docType => {
        const roleToDocType = rolesToDocumentType.find(rd => rd.documentTypeId === docType.id);

        return {
            ...docType,
            roles: roleToDocType !== undefined ? roleToDocType.roles : [],
        };
    });

    return docTypesWithRoles;
}

export function getMappedDocTypes(docTypesWithRoles, availableStudyRoles, allStudyRolesAssigned) {
    // note: if it is a staff document type and 
    // the user doesn't assign any roles, then they get all the roles
    // Filter out duplicate roles by comparing it with the initiallyAssigned Roles
    // If the role was initiallyAssigned for a documentType it will be removed from the roles array
    // Finally If the roles array is empty for a staff document it will be removed from the docTypes array.
    return docTypesWithRoles
        .map(docType => {
            const isStaffType = docType.type === 'staff';
            const noRolesSelected = !!docType.roles && docType.roles.length == 0;

            if(isStaffType) {
                docType.roles = noRolesSelected ? lodash.clone(availableStudyRoles) : docType.roles.filter(role => !role.isInitiallyAssigned);
            }
            return docType;
        })
        .filter(docType=>{
            const prevExpectation = lodash.find(allStudyRolesAssigned, prevDocType=> prevDocType.documentTypeId===docType.id);
            
            if(docType.type==='staff' && !lodash.isEmpty(prevExpectation)){
                docType.roles = lodash.differenceWith(docType.roles, prevExpectation.roles, (a,b)=>a.id===b.id);
            }
            return docType;
        });
}

export function markStaffDocumentTypes(documentTypes, staffDocumentTypes) {
    if (!staffDocumentTypes) return documentTypes;

    return documentTypes.map(documentType => {
        return staffDocumentTypes.find(staffDocumentType => staffDocumentType.id === documentType.id)
            ? { ...documentType, type: 'staff' }
            : { ...documentType, type: undefined };
    });
}

export function getDocumentType(documentTypes, id) {
    return lodash.find(
        documentTypes,
        x => x.id == id
    );
}
